import React from "react";
import DatatableComponent from "./datatable.component";

const DatatableContainer = () => {
  return <DatatableComponent />;
};

export default DatatableContainer;
